export default __webpack_public_path__ + "static/img/sign-edelweiss.2c797ff.png";